import axiosInstance from "../axios/axiosInstance";
import { getActiveCompanyId } from "utils/companyContext";

const companyId = () => getActiveCompanyId();
const unwrap = (res) => Array.isArray(res) ? res : (res?.data ?? res?.items ?? []);

export const getPaySchedules = async () => {
    const res = (await axiosInstance.get(`/companies/${companyId()}/payment_schedules`, {
        params: { active: true, page: 1, pageSize: 100 },
    })).data;
    return unwrap(res);
};

export const createPaySchedule = async (payload) => {
    return (await axiosInstance.post(`/companies/${companyId()}/payment_schedules`, payload)).data;
};

export const updatePaySchedule = async ({ scheduleId, ...payload }) => {
    return (await axiosInstance.patch(`/companies/${companyId()}/payment_schedules/${scheduleId}`, payload)).data;
};

export const deletePaySchedule = async (scheduleId) => {
    return (await axiosInstance.delete(`/companies/${companyId()}/payment_schedules/${scheduleId}`)).data;
};

export const getPaydays = async (scheduleId) => {
    return (await axiosInstance.get(`/companies/${companyId()}/payment_schedules/${scheduleId}/paydays`)).data;
};

